import { render, staticRenderFns } from "./NoSupplies.vue?vue&type=template&id=1ae3b88a&scoped=true&"
import script from "./NoSupplies.vue?vue&type=script&lang=js&"
export * from "./NoSupplies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae3b88a",
  null
  
)

export default component.exports